import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.dom-collections.iterator";
/**
 * Section: Site footer
 * ------------------------------------------------------------------------------
 * Contains highly coupled scripts to control site footer components.
 *
 * @namespace siteFooter
 */

import breakpoints from '~/helpers/breakpoints';
import cssClasses from '../helpers/cssClasses';
import { register } from '@shopify/theme-sections';
import { on } from '~/helpers/utils';
/**
 * DOM selectors.
 */

const selectors = {
  menuCaret: '[js-site-footer="menuCaret"]',
  menuColumn: '[js-site-footer="menuColumn"]',
  menuHeading: '[js-site-footer="menuHeading"]',
  menuLink: '[js-site-footer="menuLink"]'
};
/**
 * Register the `site-footer` section type.
 */

register('site-footer', {
  /**
   * Callback function when the section is loaded in via the `sections.load()`
   * function or by the Theme Editor `shopify:section:unload` event.
   */
  onLoad() {
    this.init();
  },

  /**
   * Component selectors.
   */
  setNodeSelectors() {
    this.menuCaret = document.querySelectorAll(selectors.menuCaret);
    this.menuColumn = document.querySelectorAll(selectors.menuColumn);
    this.menuHeading = document.querySelectorAll(selectors.menuHeading);
    this.menuLink = document.querySelectorAll(selectors.menuLink);
  },

  /**
   * Initialise component.
   */
  init() {
    this.setNodeSelectors();
    this.setEventListeners();
  },

  /**
   * Set event listeners.
   */
  setEventListeners() {
    [...this.menuHeading].forEach(element => {
      on('click', element, event => this.handleMenuClick(event));
    });
  },

  /**
   * Handle mobile menu click.
   * @param {Event} event - click event.
   */
  handleMenuClick(event) {
    if (window.matchMedia("(min-width: ".concat(breakpoints.large, ")")).matches) {
      return;
    }

    const menuId = event.target.dataset.id;
    [...this.menuColumn].forEach(element => {
      if (element.dataset.id === menuId) {
        this.toggleMenuElementClasses(element, cssClasses.expanded);
      } else {
        element.classList.remove(cssClasses.expanded);
        element.style.height = '47px';
      }
    });
  },

  /**
   * Toggle menu element classes.
   * @param {Object} target - element to toggle class for.
   * @param {String} class - class name to toggle.
   */
  toggleMenuElementClasses(target, className) {
    const finalHeight = this.getMenuHeight(target.dataset.id);
    let column;

    if (target.tagName.toLowerCase() === 'div') {
      column = target;
    }

    if (target.classList.contains(className)) {
      target.classList.remove(className);

      if (column) {
        column.style.height = '47px';
      }
    } else {
      target.classList.add(className);

      if (column) {
        column.style.height = "".concat(finalHeight, "px");
      }
    }
  },

  /**
   * Get height of menu column when expanded.
   * @param {String} id - id used to match elements.
   */
  getMenuHeight(targetId) {
    const headerHeight = this.menuHeading[0].offsetHeight;
    const height = this.menuLink[0].offsetHeight;
    let count = 0;
    [...this.menuLink].forEach(element => {
      if (element.dataset.id === targetId) {
        count += 1;
      }
    });
    const finalHeight = count * height + headerHeight + 10;
    return finalHeight;
  }

});